module.exports = __webpack_public_path__ + "img/Molluscs.ee89491a.svg";